// @core/api/endpoints/tag/delete_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/tag';

/**
 * Delete tag
 * Deletes a tag and removes all its assignments. Publishes untagged events for all affected entities.
 */
export async function DeleteTag(
  tag_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tags/:tag_id`;
  requestPath = requestPath.replace(':tag_id', encodeURIComponent(tag_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
